import DeleteIcon from 'Components/common/assets/svgIcons/DeleteIcon';
import DownAngleIcon from 'Components/common/assets/svgIcons/DownAngleIcon';
import GilroyWhiteSvg from 'Components/common/assets/svgIcons/GilroyWhiteSvg';
import PreviewDocIcon from 'Components/common/assets/svgIcons/PreviewDocIcon';
import SaveIcon from 'Components/common/assets/svgIcons/SaveIcon';
import ShareIcon from 'Components/common/assets/svgIcons/ShareIcon';
import SideMenuIcon from 'Components/common/assets/svgIcons/SideMenuIcon';
import DocumentHubTableSkeleton from 'Components/common/skeleton/DocumentHubTableSkeleton';
import {
  selectAccountPlanHistory, selectAccountPlanHistoryLoading,
  selectAccountPlanPodcast,
  selectAccountPlanPodcastLoading,
  selectDeleteAccountPlanLoading, selectDownloadUrl, selectInProgressPodcastCompanyId, selectLatestHistoryId,
  selectPodcastGenerateError,
  selectPodcastGenerating,
  selectPodcastPermission, selectPodcastQuota, selectPreviewUrl,
  selectSapHistoryCount, selectSapPodcastCount, selectSapSort,
  selectSapSortType, selectShareFileLoading, selectShareUrl, selectShowSapPreview,
  selectViewSapFlag,
} from 'Selector/CompaniesSelector';
import {
  FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS, PODCAST_GENERATING_NOTIFICATION, translateSkipAreas,
} from 'Utils/Constants';
import {
  IsTablet, MinWidthApp, backgroundColorParsing, getCurrentTime, valueToObject,
} from 'Utils/UtilityFunctions';
import Preview from 'Pages/document/DrawerDocViewer';
import { actions as helperActions } from 'Slice/HelperSlice';
import {
  SecondaryColor,
  greyColor,
  loadingGifV6,
  maxMobile,
  maxTablet,
  maxWidth,
  midMobile,
  midWidthApp,
  podcastFileIcon,
  pptFileIcon,
  primaryColor,
  primaryFont, primaryHeadingColor, retina,
  scrollbar, scrollbarX, secondaryFont, smMobile, textBlack, wMBold, wMedium,
} from 'Utils/utilsStyle';
import {
  Checkbox,
  Modal, Popover, Spin,
  Tooltip,
} from 'antd';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AccountPlanDocument, AccountPlanPodcast, SapSortType } from 'Types/CompaniesTypes';
import { EmailShareButton } from 'react-share';
import { actions } from 'Slice/CompaniesSlice';
import { useSearchParams } from 'react-router-dom';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import PodcastGenerateIcon from 'Components/common/assets/svgIcons/PodcastGenerateIcon';
import ProfilePopups from 'Components/common/modal/ProfilePopups';
import CreateNewSapBtn from './CreateNewSapBtn';
import PodcastCreatingScreen from './PodcastCreatingScreen';
import { selectCreateNewSap } from 'Selector/UISelector';
import DoubleUserSvg from 'Components/common/assets/svgIcons/DoubleUserSvg';
import ArrowDownIcon from 'Components/common/assets/svgIcons/ArrowDownIcon';
import {
  CaretDownOutlined,
  CaretUpOutlined,
} from '@ant-design/icons';
import FilterIcon from 'Components/common/assets/svgIcons/FilterDarkIcon';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import { SapExecutivesList } from '../../../Types/ResponseBodies';
import { selectUserId } from '../../../Selector/GlobalSearchContentSelector';
import PodcastCreatingScreenNormalView from './PodcastCreatingScreenNormalView';

const Wrapper = styled.div`
.header-filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  .SAP-filter {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid #DADADA;
    background: #FFF;
    width: 156px;
    padding: 5px 11px 5px 10px;
    gap: 10px;
    margin-right: 12px;
    position: relative;
    &.filterIsOpen {
      border: 1px solid ${primaryColor};
      .search-user {
        svg {
          path {
            fill: ${primaryColor}
          }
        }
        .search-text-div {
          color: ${primaryColor};
        }
      }
      .caret-down-icon {
        .anticon-caret-up {
          color: ${primaryColor};
        }
      }
    }
    .search-user {
      display: flex;
      align-items: center;
      column-gap: 8px;
      .search-text-div {
        color: #7E7E7E;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        letter-spacing: -0.4px;
      }
    }
    .caret-down-icon {
      border-left: 1px solid #ddd;
      padding-left: 9px;
      .anticon {
        color: #7E7E7E;
      }
    }
    &.SAP-filter-popover {
      .ant-popover {
        top: 45px !important;
        .ant-popover-content {
          .ant-popover-inner {
            width: 264px;
            height: 281px;
            padding: 0px;
            @media all and (max-width: ${midWidthApp}) {
              width: 249px;
              height: 266px;
            }
            @media all and (max-width: ${maxMobile}) {
              width: 260px;
              height: 227px;
              border-radius: 6px;
            }
          }
        }
      }
    } 
  }
}
.sap-history-tooltip {
 .ant-tooltip-inner {
  white-space: break-spaces; 
 }
 .ant-tooltip {
  inset: auto auto -66px 47px !important;
 }
}
&.nodataHistory {
  margin-top: 8px;
  width: 100%;
  .table-header-title {
    margin: 0px 12px 8px;
  }
  .smart-account-inner-style-wrapper {
    margin: 20px 12px 0px;
    height: calc(100vh - 290px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
width: 100%;
margin-top: 8px;
.table-header-title {
  display: flex;
  margin: 0px 12px 0px;
  color: ${primaryHeadingColor};
  font-family: ${secondaryFont};
  font-size: 18px;
  font-weight: ${wMBold};
  line-height: 20px;
  letter-spacing: -0.562px;
}
.no-history-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .gilroy-white-svg {
    height: 80px;
    width: 84px;
    margin-bottom: -8px;
  }
  .no-data-text {
    color: ${primaryHeadingColor};
    text-align: center;
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    letter-spacing: -0.562px;
  }
}
.smart-account-inner-style-wrapper {
  &.generatingScreen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .table-width-decide {
      .infinite-scroll-component__outerdiv {
        .infinite-scroll-component {
          height: calc(100vh - 429px) !important;
          max-height: calc(100vh - 429px);
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: calc(100vh - 415px) !important;
            max-height: calc(100vh - 415px);
          }
          @media all and (max-width: ${maxTablet}) {
            height: calc(100vh - 429px) !important;
            max-height: calc(100vh - 429px);
          }
        }
      }
    } 
  }
  &.emptyScreen {
    height: calc(100vh - 290px);
  }
  margin: 0px 12px;
  .table-width-decide {
    @media all and (max-width: ${midMobile}) {
      overflow-y: scroll;
      min-width: 450px;
      width: unset;
    }
    .table-item {
    flex: 1 1 0%;
      &:first-child {
        min-width: 290px;
        max-width: 290px;
    }
      &:last-child {
        max-width: 64px;
        min-width: 64px;
      }
    }
    .infinite-scroll-component__outerdiv {
      .infinite-scroll-component {
        height: calc(100vh - 265px) !important;
        max-height: calc(100vh - 265px);
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: calc(100vh - 255px) !important;
          max-height: calc(100vh - 255px);
        }
        @media all and (max-width: ${maxTablet}) {
          height: calc(100vh - 265px) !important;
          max-height: calc(100vh - 265px);
        }
        ${scrollbar};
        padding: 0px 8px 0px 6px;
        margin-right: 8px;
        .body-table {
          &:first-child {
            margin-top: 8px;
          }
          &.firstDisabled {
            .ant-popover-inner {
              .action-point.generation {
                opacity: 0.5;
                pointer-events: none;
              }
            }
          }
          &.onlyFirstElement {
            &:nth-child(1){
              .ant-popover-inner {
                .action-point.generation { 
                  opacity: 1;
                  pointer-events: auto;
                } 
              }
            }
            .ant-popover-inner {
              .action-point.generation {
                opacity: 0.5;
                pointer-events: none;
              }
            }
          }
        }
        .document-hub-table-skelton-wrapper {
          padding: 0px;
          .document-detail-skeleton-wrapper {
            padding: 16px;
            .name-div {
              .skeleton-box {
                &:first-child {
                  @media all and (max-width: ${maxWidth}), ${retina} {
                    width: 45px;
                    min-width: 45px;
                  }
                }
              }
            }
            .skeleton-box {
              @media all and (max-width: ${maxWidth}), ${retina} {
                width: 130px;
                min-width: 130px;
              }
              &:nth-child(3), :nth-child(4) {
                display: none !important;
              }
            }
          }
        }
      }
    }
  }
}

`;

const InnerStyleWrapper = styled.div`
  @media all and (max-width: ${smMobile}) { 
    overflow-x: scroll;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    ${scrollbarX};
    padding: 0 10px;
    .table-item {
      @media all and (max-width: ${smMobile}) {
        min-width: 200px;
        &:first-child {
          min-width: 380px;
          max-width: 380px;
        }
      }
    }
  }
`;
const TableHeader = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid #DDDDDD;
  padding: 22px 40px 5px 22px;
  margin: 0px 0px;
  .table-item {
    position: relative;
    padding: 0px 5px;
    &:first-child {
      .heading-div {
        padding-left: 59px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding-left: 52px;
        }
      }
    }
    .heading-div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      pointer-events: none;
      .heading-text {
        cursor: pointer;
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 18px;
        letter-spacing: -0.333px;
        color: #5E7079;
        margin-bottom: 0px;
      }
      .action-div {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        display: none;
        svg {
          width: 8px;
          height: 8px;
          cursor: pointer;
          &:first-child {
            transform: rotate(180deg);
            margin-bottom: 1px;
          }
        }
      }
    }
  }
  `;

const TableBody = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);  
  border-radius: 10px;
  background: #FFF;
  width: 100%;
  margin-bottom: 8px;
  height: 80px;
  padding: 21px 20px 21px 16px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 70px;
  }
  &.activeDrawer{
    border: 1px solid ${primaryColor}
  }
  .table-item {
    text-align: start;
    position: relative;
    padding: 0px 5px;
    .date-text {
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 24px;
      letter-spacing: -0.375px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 14px;
      }
    }
    .menu-download-div {
      display: flex;
      align-items: center;
      justify-content: center;
      .save-icon-svg {
        width: 25px;
        height: 20px;
        margin-right: 16px;
        cursor: pointer;
      }
      .side-menu-popover {
        height: 24px;
        cursor: pointer;
        .ant-popover {
          left: -140px !important;
          top: -36px !important;
          .ant-popover-content {
            width: 185px;
            .ant-popover-arrow {
              right: 0px !important;
              height: 20px !important;
            }
            .ant-popover-inner {
              border-radius: 8px;
              padding: 0px;
              .ant-popover-inner-content {
                padding: 12px 16px !important;
                .social-icons-slide-mail {
                  margin-top: 10px;
                }
                .actions-div {
                  display: flex;
                  flex-direction: column;
                  .action-point {
                    display: flex;
                    align-items: center;
                    font-family: ${primaryFont};
                    font-size: 16px;
                    font-weight: ${wMedium};
                    line-height: 24px;
                    letter-spacing: -0.4px;
                    color: ${SecondaryColor};
                    margin-top: 10px;
                    cursor: pointer;
                    &:nth-child(1) {
                      margin-top: 0px;
                    }
                    .ant-spin-spinning {
                      margin-right: 10px;
                      .ant-spin-dot-spin {
                        font-size: 15px;
                      }
                    }
                    &:hover {
                      color: ${primaryColor};
                      svg {
                        path {
                          fill: ${primaryColor};
                        }
                      }
                    }
                    svg {
                      width: 18px;
                      min-width: 18px;
                      height: 18px;
                      margin-right: 8px;
                    }
                    .preview-doc-icon-svg {
                      width: 16px;
                      height: 15px;
                    }
                    &.remove{
                      color: #CF1322;
                      &:hover {
                      color: #CF1322;
                      svg {
                        path {
                          fill: #CF1322;
                        }
                      }
                    }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `;

const FileName = styled.div`
  display: flex;
  align-items: center;
  .ant-badge {
    .ant-badge-dot {
      width: 14px;
      height: 14px;
      background-color: ${primaryColor};
      left: 23px;
      top: 5px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 12px;
        height: 12px;
      }
    }
  }
  .rename-text-box-global-style-wrapper {
    width: calc(100% - 48px);
    .edit-actions-div {
      top: 9px;
      right: 12px;
    }
  }
  .file-img {
    width: 37px;
    min-width: 37px;
    height: 37px;
    margin-right: 17px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin-right: 10px;
    }
  }
  .file-created-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 4px;
    .created-by {
      display: flex;
      align-items: center;
      column-gap: 5px;
      .person-img {
        .person-without-holo {
          @media all and (max-width: ${maxWidth}), ${retina} {            
            padding: 1px !important;
          }
        }
      }
      .text-div {
        color: ${primaryHeadingColor};
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 16px;
        letter-spacing: -0.417px;
      }
      .person-name {
        color: #000;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 16px;
        letter-spacing: -0.417px;
        max-width: 120px;
      }
    }
  }
  .file-name {
    color: #000;
    font-family: ${secondaryFont};
    font-size: 18px;
    font-weight: ${wMedium};
    line-height: 24px;
    letter-spacing: -0.417px;
    margin-bottom: 0px;
    max-width: 220px;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
    }
  }
  .file-name-no-cursor {
    cursor: default;
    &:hover {
      text-decoration: none;
    }
  }
  .highlighted {
    color: ${primaryColor};
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
  `;

const ContentWrapper = styled.div`
  border-radius: 12px;
  box-shadow: 0 2px 60px 0 rgba(0, 0, 0, 0.28);
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 12px 16px 12px 24px;
    border-radius: 12px 12px 0 0;
    background: #FFF;
    @media all and (max-width: ${maxMobile}) {
      padding: 10px 13px 10px 20px;
    }
    .icon-text-div {
      display: flex;
      align-items: baseline;
      .filter-icon-dropdown {
        width: 15px;
        height: 13px;
        flex-shrink: 0;
        @media all and (max-width: ${maxMobile}) {
          width: 12px;
          height: 10px;
        }
      }
      .div-text {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.422px;
      }
    }
    .apply-btn {
      cursor: pointer;
      color: #FFF;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMBold};
      line-height: normal;
      background: ${primaryColor};
      text-align: center;
      padding: 6px 12px;
      border-radius: 8px;
    }
    .disabled-text {
      text-align: center;
      color: rgb(245, 34, 45);
      font-size: 14px;
      font-weight: ${wMedium};
      font-family: ${primaryFont};
      letter-spacing: -0.4px;
      margin-top: 5px;
    }
  }
  .content-div {
    border-radius: 0px 0px 12px 12px;
    background: #F8F8F8;
    padding: 8px 22px;
    height: 226px;
    .heading {
      display: flex;
      align-content: center;
      justify-content: space-between;
      .heading-text {
        color: ${greyColor};
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 20px;
        letter-spacing: -0.375px;
      }
      .select-btn {
        cursor: pointer;
        span {
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMedium};
          line-height: 20px;
          letter-spacing: -0.375px;
        }
      }
    }
    .search-wrapper {
      .ant-input-affix-wrapper {
        height: 28px; 
        padding: 6px 12px;
        input {
          &::placeholder {
            color: #C1C1C1;
            font-family: Roboto;
            font-size: 14.4px;
            font-style: italic;
            font-weight: 400;
            line-height: 16px; /* 111.111% */
            letter-spacing: -0.32px;
          }
          color: ${textBlack};
            font-family: Roboto;
            font-size: 14.4px;
            font-weight: 400;
            line-height: 16px; /* 111.111% */
            letter-spacing: -0.32px;
        }
      }
      .cross-icon {
        top:6px;
        right: 10px;
        height: 16px;
      }
      svg {
        height: 13px;
      }
    }
    .scroll-div  {
      height: 150px !important;
      max-height: 150px;
      ${scrollbar}
      .executive-div {
        display: flex;
        align-items: center;
        column-gap: 8px;
        padding: 6px 0px;
        .ant-checkbox-wrapper {
          width: auto;
          margin-bottom: 0px;
        }
        .person-without-holo {
          @media all and (max-width: ${maxWidth}), ${retina}
          {
            padding: 1px !important;
          }
        }
        .name {
          color: ${textBlack};
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMedium};
          line-height: 20px;
          letter-spacing: -0.4px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }
      }
    }
    .no-results {
      color: ${textBlack};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 20px;
      letter-spacing: -0.4px;
      padding: 12px 0px;
    }
  }
`;
type PopOverProps = {
  type: 'history' | 'podcast';
  onPreview: () => void;
  onDelete: () => void;
  onShare: () => void;
  onGeneratePodcast: () => void;
  disablePodcastGenerate: boolean
  podcastPermission: boolean
  isDeleteAllow?: boolean
};

const PopoverContent = function PopoverContent(props: PopOverProps) {
  const {
    onShare, onPreview, onDelete, type, disablePodcastGenerate, podcastPermission,
    onGeneratePodcast, isDeleteAllow,
  } = props;
  const showSapPreview = useSelector(selectShowSapPreview);
  const shareUrl = useSelector(selectShareUrl);
  const isLoading = useSelector(selectShareFileLoading);
  const isTab = MinWidthApp();
  const emailShareButtonRef = useRef<HTMLButtonElement>(null);
  const viewSapFlag = useSelector(selectViewSapFlag);

  useEffect(() => {
    if (shareUrl && emailShareButtonRef.current && !showSapPreview) {
      emailShareButtonRef.current.click();
    }
  }, [shareUrl]);

  return (
    <div className="actions-div">
      {type === 'history' && podcastPermission ? (
        <span tabIndex={0} role="button" className={classNames('action-point generation')} onClick={onGeneratePodcast} onKeyDown={onGeneratePodcast}>
          <PodcastGenerateIcon color={SecondaryColor} />
          Generate Podcast
        </span>
      ) : null}

      {!isTab && type === 'history' ? (
        <span tabIndex={0} role="button" className="action-point" onClick={onPreview} onKeyDown={onPreview}>
          <PreviewDocIcon color={SecondaryColor} />
          Preview
        </span>
      ) : null}

      {shareUrl && !showSapPreview && type === 'history' && (
        <EmailShareButton
          className="social-icons-slide-mail smart-btn"
          url={shareUrl || ''}
          body=""
          subject="Smart Account Plan"
          separator={'\r\n\r\n'}
        >
          <span tabIndex={0} role="button" className="action-point" ref={emailShareButtonRef}>
            <ShareIcon color={SecondaryColor} />
            Share
          </span>
        </EmailShareButton>
      )}

      {!shareUrl && type === 'history' && (
        <span tabIndex={0} role="button" className="action-point" onClick={onShare} onKeyDown={onShare}>
          {isLoading ? <Spin /> : <ShareIcon color={SecondaryColor} />}
          Share
        </span>
      )}

      <span tabIndex={0} role="button" className={classNames('action-point remove', {
        disabled: viewSapFlag ? !isDeleteAllow : false
      })} onClick={onDelete} onKeyDown={onDelete}>
        <DeleteIcon color="#CF1322" />
        Delete
      </span>
    </div>
  );
};


type Props = {
  podcastGenerate?: boolean;
  sapListOfExecutives?: SapExecutivesList[];
  podcastListOfExecutives?: SapExecutivesList[];
  selectedSapExecutives?: number[];
  selectedPodcastExecutives?: number[];
  setSelectedSapExectuives?: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedPodcastExecutives?: React.Dispatch<React.SetStateAction<number[]>>;
} & typeof defaultProps;
const defaultProps = {
  podcastGenerate: false,
};
const SmartAccountPlanHistoryTable = function SmartAccountPlanHistoryTable(props: Props) {
  const { podcastGenerate, sapListOfExecutives, podcastListOfExecutives, selectedSapExecutives, selectedPodcastExecutives, setSelectedSapExectuives, setSelectedPodcastExecutives } = props;
  const accountPlanHistory = useSelector(selectAccountPlanHistory);
  const accountPlanPodcast = useSelector(selectAccountPlanPodcast);
  const sapHistoryCount = useSelector(selectSapHistoryCount);
  const accountPlanHistoryLoading = useSelector(selectAccountPlanHistoryLoading);
  const sapPodcastCount = useSelector(selectSapPodcastCount);
  const accountPlanPodcastLoading = useSelector(selectAccountPlanPodcastLoading);
  const latestHistoryId = useSelector(selectLatestHistoryId);
  const podcastPermission = useSelector(selectPodcastPermission);
  const podcastGenerating = useSelector(selectPodcastGenerating);
  const sort = useSelector(selectSapSort);
  const sortType = useSelector(selectSapSortType);
  const deleteLoading = useSelector(selectDeleteAccountPlanLoading);
  const showSapPreview = useSelector(selectShowSapPreview);
  const downloadUrl = useSelector(selectDownloadUrl);
  const previewUrlUrl = useSelector(selectPreviewUrl);
  const podcastError = useSelector(selectPodcastGenerateError);
  const [isVisiblePopup, setVisiblePopup] = useState(false);
  const [shareFile, setShareFile] = useState(false);
  const [selectedSapDoc, setSelectedSapDoc] = useState<AccountPlanDocument | AccountPlanPodcast | null>(null);
  const [tableRowId, setTableRowId] = useState<number | null>();
  const dispatch = useDispatch();
  const startTime = getCurrentTime();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const isTab = IsTablet();
  const isMinWidth = MinWidthApp();
  const generatingScreen = podcastGenerate && (podcastGenerating || (!accountPlanPodcast.length && !accountPlanPodcastLoading));
  const showPodcastScreenMsgs = (podcastGenerating || podcastError || (!accountPlanPodcastLoading
    && !accountPlanPodcast.length))
    && podcastGenerate;
  const inProgressCompanyId = useSelector(selectInProgressPodcastCompanyId);
  const limitPopup = useSelector(selectPodcastQuota);
  const createNewSapGen = useSelector(selectCreateNewSap);
  const [isOpen, setIsOpen] = useState(false);
  const viewSapFlag = useSelector(selectViewSapFlag);

  const [sapFilterExecutives, setSapFilterExecutives] = useState(sapListOfExecutives || []);
  const [podcastFilterExec, setPodcastFilterExec] = useState(podcastListOfExecutives || []);
  const [searchTerm, setSearchTerm] = useState('');
  const allSapSelected = sapFilterExecutives.every(exec => selectedSapExecutives?.includes(exec.userId));
  const allPodcastSelected = podcastFilterExec.every(exec => selectedPodcastExecutives?.includes(exec.userId));
  const activeUserId = useSelector(selectUserId);
  const tableHeader = [
    {
      title: 'Name',
      type: 'name',
    },
    {
      title: 'Date',
      type: 'date',
    },
    {
      title: '',
      type: '',
    },
  ];

  useEffect(() => {
    setPodcastFilterExec(podcastListOfExecutives || []);
  }, [podcastListOfExecutives])

  useEffect(() => {
    setSapFilterExecutives(sapListOfExecutives || []);
  }, [sapListOfExecutives])

  // Clean up selected executives when they're removed from filter lists
  useEffect(() => {
    if (sapFilterExecutives.length > 0 && setSelectedSapExectuives) {
      const validIds = (selectedSapExecutives ?? []).filter(id =>
        sapFilterExecutives.some(exec => exec.userId === id)
      );
      if (validIds.length !== (selectedSapExecutives ?? []).length) {
        setSelectedSapExectuives(validIds);
      }
    }
  }, [sapFilterExecutives]);

  useEffect(() => {
    if (podcastFilterExec.length > 0 && setSelectedPodcastExecutives) {
      const validIds = (selectedPodcastExecutives ?? []).filter(id =>
        podcastFilterExec.some(exec => exec.userId === id)
      );
      if (validIds.length !== (selectedPodcastExecutives ?? []).length) {
        setSelectedPodcastExecutives(validIds);
      }
    }
  }, [podcastFilterExec]);

  const handlePlanDownload = (documentId: number, type: 'history' | 'podcast') => {
    if (type === 'history') {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('download_account_plan', startTime, {}),
      ));
      dispatch(actions.getDocumentDownloadURL({ id: documentId, type: 'history' }));
    } else {
      dispatch(actions.getDocumentDownloadURL({ id: documentId, type: 'podcast' }));
      dispatch(helperActions.callFlurryEvent(
        valueToObject('podcast_download', startTime, {
          // id: selectedSapDoc?.id,
          host: window.location.href,
        }),
      ));
    }
  };

  const handlePlanShare = (documentId: number) => {
    dispatch(helperActions.callFlurryEvent(
      valueToObject('share_account_plan', startTime, {}),
    ));
    setShareFile(true);
    dispatch(actions.getDocumentDownloadURL({ id: documentId, type: 'history' }));
  };

  useEffect(() => {
    if (downloadUrl && !showSapPreview && !shareFile && !createNewSapGen) {
      const anchorTag = document.createElement('a');
      anchorTag.href = downloadUrl;
      if (podcastGenerate) {
        anchorTag.target = '_blank';
      }
      anchorTag.dispatchEvent(new MouseEvent('click'));

      if (anchorTag) {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    }
    dispatch(actions.removeDocumentDownloadURL());
  }, [downloadUrl]);

  const fetchMore = () => {
    if (podcastGenerate) {
      dispatch(actions.getAccountPlanHistory({
        offset: accountPlanPodcast?.length,
        sortType,
        sort,
        companyId: companyIdParsed,
        type: 'podcast',
        ...(((selectedPodcastExecutives ?? []).length > 0) && { filter: (selectedPodcastExecutives ?? []).join(",") }),
      }));
    } else {
      dispatch(actions.getAccountPlanHistory({
        offset: accountPlanHistory?.length,
        sortType,
        sort,
        companyId: companyIdParsed,
        type: 'history',
        ...(((selectedSapExecutives ?? []).length > 0) && { filter: (selectedSapExecutives ?? []).join(",") }),
      }));
    }
  };

  const onSortClick = (type: SapSortType) => {
    if ((podcastGenerate && !accountPlanPodcastLoading)
      || (!podcastGenerate && !accountPlanHistoryLoading)) {
      dispatch(actions.toggleSort(type));
    }
  };

  const handleDelete = () => {
    dispatch(actions.deleteAccountPlan({
      id: selectedSapDoc?.id || 0,
      ...(podcastGenerate && { type: 'podcast' }),
      userId: activeUserId,
    }));
    if (podcastGenerate && selectedSapDoc?.id) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('podcast_delete', startTime, {
          id: selectedSapDoc?.id,
          url: window.location.href,
        }),
      ));
    }
    setVisiblePopup(false);
  };

  const togglePopup = () => {
    setVisiblePopup(!isVisiblePopup);
  };

  const setShowSapPreview = (show: boolean) => {
    dispatch(actions.setShowSapPreview(show));
  };

  const handlePreview = (doc: AccountPlanDocument) => {
    if (!isMinWidth) {
      setShowSapPreview(true);
      setSelectedSapDoc(doc);
      dispatch(actions.getDocumentDownloadURL({ id: doc.id, type: 'history' }));
      setTableRowId(doc?.id);
    }
  };

  const handleGeneratePodcast = () => {
    if (selectedSapDoc?.id) {
      dispatch(actions.createPodcast({
        id: selectedSapDoc.id,
        companyId: companyIdParsed,
      }));
      dispatch(helperActions.callFlurryEvent(
        valueToObject('podcast_generate_click', startTime, {
          // id: selectedSapDoc?.id,
          host: window.location.href,
        }),
      ));
    }
  };

  const handleRefresh = () => {
    dispatch(actions.getAccountPlanHistory({
      offset: 0,
      sortType,
      sort,
      companyId: companyIdParsed,
      type: 'podcast',
    }));
  };

  const handleSearching = <T extends { personName: string }>(
    text: string,
    executivesList: T[],
    setExecutivesList?: React.Dispatch<React.SetStateAction<T[]>>
  ) => {
    if (!setExecutivesList) return;
    setSearchTerm(text);
    if (text.length > 0) {
      const filtered = executivesList.filter(exec =>
        exec.personName.toLowerCase().includes(text.toLowerCase())
      )
      setExecutivesList(filtered);
    } else {
      setExecutivesList(executivesList);
    }
  }

  const handleCheckboxChange = (id: number, setExecutivesList?: React.Dispatch<React.SetStateAction<number[]>>) => {
    if (!setExecutivesList) return;
    setExecutivesList(prev =>
      prev.includes(id)
        ? prev.filter(uid => uid !== id)
        : [...prev, id]
    );
  };

  // Get valid selected executives that exist in current filter list
  const getValidSelectedExecutives = (
    selectedIds: number[],
    filterList: { userId: number }[]
  ) => {
    const validIds = selectedIds.filter(id =>
      filterList.some(exec => exec.userId === id)
    );
    return validIds;
  };

  // Check if there are any valid selected executives
  const hasValidSelection = podcastGenerate
    ? getValidSelectedExecutives(selectedPodcastExecutives ?? [], podcastFilterExec).length > 0
    : getValidSelectedExecutives(selectedSapExecutives ?? [], sapFilterExecutives).length > 0;

  const handleApply = () => {
    if (podcastGenerate) {
      const validPodcastExecs = getValidSelectedExecutives(selectedPodcastExecutives ?? [], podcastFilterExec);
      if (validPodcastExecs.length > 0) {
        const selectedPodcastUsers = validPodcastExecs.join(",");
        dispatch(actions.getAccountPlanHistory({
          offset: 0,
          sortType,
          sort,
          companyId: companyIdParsed,
          filter: selectedPodcastUsers,
          type: 'podcast',
        }));
      }
    } else {
      const validSapExecs = getValidSelectedExecutives(selectedSapExecutives ?? [], sapFilterExecutives);
      if (validSapExecs.length > 0) {
        const selectedSapUsers = validSapExecs.join(",");
        dispatch(actions.getAccountPlanHistory({
          offset: 0,
          sortType,
          sort,
          companyId: companyIdParsed,
          filter: selectedSapUsers,
          type: 'history',
        }));
      }
    }
    setIsOpen(false);
  }

  const handleSelect = (
    allSelected: boolean,
    filterExecutives: { userId: number }[],
    setSelectedExecutives?: React.Dispatch<React.SetStateAction<number[]>>,
  ) => {
    if (!setSelectedExecutives) return;
    if (allSelected) {
      setSelectedExecutives(prev =>
        prev.filter(id => !filterExecutives.some(exec => exec.userId === id))
      );
    } else {
      setSelectedExecutives(prev => [
        ...new Set([...prev, ...filterExecutives.map(exec => exec.userId)])
      ]);
    }
  }

  // Cleanup effect to prevent DOM manipulation issues
  useEffect(() => {
    return () => {
      // Reset states when component unmounts or tab changes
      setVisiblePopup(false);
      setShareFile(false);
      setSelectedSapDoc(null);
      setTableRowId(null);
      setIsOpen(false);
    };
  }, [podcastGenerate]);

  const content = (
    <ContentWrapper>
      <div className='header'>
        <div className='icon-text-div'>
          <FilterIcon color={primaryHeadingColor} />
          <span className="div-text">Filter</span>
        </div>
        <span
          tabIndex={0}
          role='button'
          className={classNames('apply-btn', {
            disabled: !hasValidSelection
          })}
          onClick={handleApply}
        >
          Apply
        </span>
        {
          !hasValidSelection && (
            <span className='disabled-text'>Please select one filter atleast</span>
          )
        }
      </div>
      {
        !podcastGenerate ? (
          <div className='content-div'>
            <h4 className='heading'>
              <span className='heading-text'>
                Search by name:
              </span>
              <div
                role='button'
                className='select-btn primary-color'
                onClick={() => handleSelect(allSapSelected, sapFilterExecutives, setSelectedSapExectuives)}
              >
                {
                  allSapSelected ? <span>unselect all</span> : <span>select all</span>
                }
              </div>
            </h4>
            <AlertsSearch
              placeholderText='Search applicants'
              margin='0px'
              onSearching={text => handleSearching(text, sapListOfExecutives ?? [], setSapFilterExecutives)}
            />
            <div className='scroll-div'>
              {
                sapFilterExecutives.length ? (
                  sapFilterExecutives.map((exec) => (
                    <div className='executive-div'>
                      <Checkbox
                        checked={selectedSapExecutives?.includes(exec.userId)}
                        onChange={() => handleCheckboxChange(exec.userId, setSelectedSapExectuives)}
                      />
                      <PeopleWidgetWithOutHolo
                        logo={exec?.personImage}
                        wrapperColor={exec?.personalityTypes?.[0]?.color || '#CCCCCC'}
                        diameter='24px'
                        diameterSm='24px'
                        diameterXsm='20px'
                        ringPadding='1px'
                        persona='#F0B520'
                        margin='0px'
                      />
                      <span className='name'>{exec.personName}</span>
                    </div>
                  ))
                ) : (
                  <div className='no-results'>
                    No Results Found
                  </div>
                )
              }
            </div>
          </div>
        ) : (
          <div className='content-div'>
            <h4 className='heading'>
              <span className='heading-text'>
                Search by name:
              </span>
              <div
                role='button'
                className='select-btn primary-color'
                onClick={() => handleSelect(allPodcastSelected, podcastFilterExec, setSelectedPodcastExecutives)}
              >
                {
                  allPodcastSelected ? <span>unselect all</span> : <span>select all</span>
                }
              </div>
            </h4>
            <AlertsSearch
              placeholderText='Search applicants'
              margin='0px'
              onSearching={text => handleSearching(text, podcastListOfExecutives ?? [], setPodcastFilterExec)}
            />
            <div className='scroll-div'>
              {
                podcastFilterExec.length ? (
                  podcastFilterExec.map((exec) => (
                    <div className='executive-div'>
                      <Checkbox
                        checked={(selectedPodcastExecutives ?? []).includes(exec.userId)}
                        onChange={() => handleCheckboxChange(exec.userId, setSelectedPodcastExecutives)}
                      />
                      <PeopleWidgetWithOutHolo
                        logo={exec?.personImage}
                        wrapperColor={exec?.personalityTypes?.[0]?.color || '#CCCCCC'}
                        diameter='24px'
                        diameterSm='24px'
                        diameterXsm='20px'
                        ringPadding='1px'
                        persona='#F0B520'
                        margin='0px'
                      />
                      <span className='name'>{exec.personName}</span>


                    </div>
                  ))
                ) : (
                  <div className='no-results'>
                    No Results Found
                  </div>
                )
              }
            </div>
          </div>
        )
      }
    </ContentWrapper>
  )

  // Find index of first document belonging to logged-in user (for history only)
  const getFirstUserDocIndex = (docs: (AccountPlanDocument | AccountPlanPodcast)[], userId: number) => {
    return docs.findIndex(doc => doc.createdBy?.userId === userId);
  };

  const firstUserHistoryIndex = getFirstUserDocIndex(accountPlanHistory, activeUserId);

  // Helper function to render table rows for podcast
  const renderPodcastRow = (doc: AccountPlanPodcast, index: number) => {
    return (
      <TableBody key={`podcast-${doc?.id}`} className={classNames('body-table', {
        activeDrawer: doc?.id === tableRowId
      })}>
        <span className="table-item">
          <FileName className={`table-item-file-name ${translateSkipAreas}`}>
            <img src={podcastFileIcon} alt="file-type-icon" className="file-img" />
            <div className='file-created-div'>
              <Tooltip
                placement="bottom"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip sap-history-tooltip"
                color="#fff"
                title={doc?.name}
                zIndex={1}
                arrow={false}
              >
                <span
                  className={classNames('file-name text-truncate', {
                    highlighted: doc?.id === tableRowId,
                    'file-name-no-cursor': isMinWidth,
                  })}
                >
                  {doc?.name}
                </span>
              </Tooltip>
              {viewSapFlag && (
                <div className='created-by'>
                  <span className='text-div'>Created by:</span>
                  <div className='person-img'>
                    <PeopleWidgetWithOutHolo
                      logo={doc?.createdBy?.personImage}
                      wrapperColor={doc?.createdBy?.personalityTypes?.[0]?.color || '#CCCCCC'}
                      diameter='24px'
                      diameterSm='24px'
                      diameterXsm='20px'
                      ringPadding='1px'
                      persona="#F0B520"
                      margin="0px"
                    />
                  </div>
                  <span className='person-name'>{doc?.createdBy?.personName}</span>
                </div>
              )}
            </div>
          </FileName>
        </span>
        <span className="table-item">
          <span className="date-text">{doc?.date}</span>
        </span>
        <span className="table-item">
          <div className="menu-download-div">
            <SaveIcon
              color={primaryColor}
              onClick={() => handlePlanDownload(doc?.id, 'podcast')}
            />
            {!isVisiblePopup || deleteLoading ? (
              <Popover
                onOpenChange={() => setSelectedSapDoc(doc)}
                getPopupContainer={(e: HTMLElement) => e}
                arrow={false}
                content={(
                  <PopoverContent
                    onPreview={() => { }}
                    onDelete={togglePopup}
                    onShare={() => { }}
                    onGeneratePodcast={() => { }}
                    type="podcast"
                    disablePodcastGenerate
                    podcastPermission={false}
                    isDeleteAllow={doc?.isDeleteAllow}
                  />
                )}
                trigger="click"
                placement="left"
                className="side-menu-popover"
                autoAdjustOverflow={false}
                zIndex={100000}
              >
                {!(deleteLoading && selectedSapDoc?.id === doc.id) && (
                  <span>
                    <SideMenuIcon color="#A0A0A0" />
                  </span>
                )}
              </Popover>
            ) : null}
            {deleteLoading && selectedSapDoc?.id === doc.id ? <Spin /> : null}
          </div>
        </span>
      </TableBody>
    );
  };

  // Helper function to render table rows for history
  const renderHistoryRow = (doc: AccountPlanDocument, index: number) => {
    const isFirstUserDoc = viewSapFlag && index === firstUserHistoryIndex && doc.createdBy?.userId === activeUserId;

    return (
      <TableBody key={`history-${doc?.id}`} className={classNames('body-table', {
        activeDrawer: doc?.id === tableRowId,
        'firstDisabled': !isFirstUserDoc,
        'onlyFirstElement': !viewSapFlag
      })}>
        <span className="table-item">
          <FileName className={`table-item-file-name ${translateSkipAreas}`}>
            <img src={pptFileIcon} alt="file-type-icon" className="file-img" />
            <div className='file-created-div'>
              <Tooltip
                placement="bottom"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip sap-history-tooltip"
                color="#fff"
                title={doc?.name}
                zIndex={1}
                arrow={false}
              >
                <span
                  className={classNames('file-name text-truncate', {
                    highlighted: doc?.id === tableRowId,
                    'file-name-no-cursor': isMinWidth,
                  })}
                  onClick={() => handlePreview(doc)}
                  onKeyDown={() => handlePreview(doc)}
                  tabIndex={0}
                  role="button"
                >
                  {doc?.name}
                </span>
              </Tooltip>
              {viewSapFlag && (
                <div className='created-by'>
                  <span className='text-div'>Created by:</span>
                  <div className='person-img'>
                    <PeopleWidgetWithOutHolo
                      logo={doc?.createdBy?.personImage}
                      wrapperColor={doc?.createdBy?.personalityTypes?.[0]?.color || '#CCCCCC'}
                      diameter='24px'
                      diameterSm='24px'
                      diameterXsm='20px'
                      ringPadding='1px'
                      persona="#F0B520"
                      margin="0px"
                    />
                  </div>
                  <span className='person-name text-truncate'>{doc?.createdBy?.personName}</span>
                </div>
              )}
            </div>
          </FileName>
        </span>
        <span className="table-item">
          <span className="date-text">{doc?.date}</span>
        </span>
        <span className="table-item">
          <div className="menu-download-div">
            <SaveIcon
              color={primaryColor}
              onClick={() => handlePlanDownload(doc?.id, 'history')}
            />
            {!isVisiblePopup || deleteLoading ? (
              <Popover
                onOpenChange={() => setSelectedSapDoc(doc)}
                getPopupContainer={(e: HTMLElement) => e}
                arrow={false}
                content={(
                  <PopoverContent
                    onPreview={() => handlePreview(doc)}
                    onDelete={togglePopup}
                    onShare={() => handlePlanShare(doc?.id)}
                    onGeneratePodcast={handleGeneratePodcast}
                    type="history"
                    disablePodcastGenerate={!doc?.isPodcastGenerationAvailable}
                    podcastPermission={podcastPermission}
                    isDeleteAllow={doc?.isDeleteAllow}
                  />
                )}
                trigger="click"
                placement="left"
                className="side-menu-popover"
                autoAdjustOverflow={false}
                zIndex={100000}
              >
                {!(deleteLoading && selectedSapDoc?.id === doc.id) && (
                  <span>
                    <SideMenuIcon color="#A0A0A0" />
                  </span>
                )}
              </Popover>
            ) : null}
            {deleteLoading && selectedSapDoc?.id === doc.id ? <Spin /> : null}
          </div>
        </span>
      </TableBody>
    );
  };

  // Determine if table should be shown
  const shouldShowTable = (podcastGenerate && (!viewSapFlag ? !podcastGenerating : true) && (accountPlanPodcastLoading || accountPlanPodcast?.length))
    || (!podcastGenerate && (accountPlanHistoryLoading || accountPlanHistory?.length));

  // Determine if header should be shown
  const shouldShowHeader = viewSapFlag || accountPlanHistory?.length || (!accountPlanHistory?.length && accountPlanHistoryLoading);

  return (
    <Wrapper className={classNames('smart-account-plan-history-table', { nodataHistory: accountPlanHistory?.length === 0 && !accountPlanHistoryLoading })}>
      {shouldShowHeader && (
        <div className='header-filter-section'>
          <h6 className="table-header-title">
            {podcastGenerate ? 'Podcast' : 'History'}
            {(!accountPlanHistory?.length && accountPlanHistoryLoading && !podcastGenerate) || ((!accountPlanPodcast?.length && accountPlanPodcastLoading && podcastGenerate && !podcastGenerating)) ? <SkeletonCustom height="20px" width="20px" margin="0px 0px 0px 5px" /> : podcastGenerate && podcastGenerating ? null : ` (${podcastGenerate ? sapPodcastCount : sapHistoryCount})`}
          </h6>
          {viewSapFlag && (
            <Popover
              open={isOpen}
              content={content}
              trigger="click"
              placement="bottomLeft"
              onOpenChange={setIsOpen}
              getPopupContainer={(e: HTMLElement) => e}
              className='SAP-filter-popover'
            >
              <span
                role="button"
                className={classNames('SAP-filter', { filterIsOpen: isOpen })}
                tabIndex={0}
                aria-label='SAP-filter'
                onClick={() => setIsOpen(!isOpen)}
              >
                <div className='search-user'>
                  <DoubleUserSvg />
                  <span className='search-text-div'>by User</span>
                </div>
                <span className='caret-down-icon'>
                  {isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                </span>
              </span>
            </Popover>
          )}
        </div>
      )}

      <InnerStyleWrapper className={classNames('smart-account-inner-style-wrapper', { generatingScreen, emptyScreen: viewSapFlag ? accountPlanPodcast.length === 0 : false })}>
        {accountPlanHistory?.length === 0 && !accountPlanHistoryLoading && !podcastGenerate && (
          <div className="no-history-div">
            <GilroyWhiteSvg />
            <span className="no-data-text">No Smart Account Plans exist for this company</span>
            <CreateNewSapBtn noHistoryStyle companyId={companyIdParsed} />
          </div>
        )}

        {showPodcastScreenMsgs && viewSapFlag ? (
          <PodcastCreatingScreen
            type={podcastGenerating && accountPlanHistory?.length > 0 ? 'creating' : podcastError ? 'refresh' : 'empty'}
            onRefresh={handleRefresh}
          />
        ) : null}

        {showPodcastScreenMsgs && !viewSapFlag ? (
          <PodcastCreatingScreenNormalView
            type={podcastGenerating && accountPlanHistory.length > 0 ? 'creating' : podcastError ? 'refresh' : 'empty'}
            onRefresh={handleRefresh}
          />
        ) : null}

        {shouldShowTable ? (
          <div className={classNames("table-width-decide w-100", { isPodcastTable: viewSapFlag ? podcastGenerate : false })}>
            <TableHeader className="header-table">
              {tableHeader?.map((heading, index) => (
                <span className="table-item" key={heading.type || index}>
                  <div className="heading-div">
                    <span
                      className="heading-text"
                      onClick={() => onSortClick(heading.type as SapSortType)}
                      onKeyDown={() => onSortClick(heading.type as SapSortType)}
                      role="button"
                      tabIndex={0}
                    >
                      {heading.title}
                    </span>
                    {index !== 2 && (
                      <div
                        className="action-div"
                        onClick={() => onSortClick(heading.type as SapSortType)}
                        onKeyDown={() => onSortClick(heading.type as SapSortType)}
                        role="button"
                        tabIndex={0}
                      >
                        <DownAngleIcon color={sort === 'asc' && sortType === heading.type ? primaryColor : '#5E7079'} />
                        <DownAngleIcon color={sort === 'des' && sortType === heading.type ? primaryColor : '#5E7079'} />
                      </div>
                    )}
                  </div>
                </span>
              ))}
            </TableHeader>
            <InfiniteScroll
              dataLength={podcastGenerate ? accountPlanPodcast?.length : accountPlanHistory?.length}
              next={fetchMore}
              hasMore={viewSapFlag ? podcastGenerate ? (accountPlanPodcast?.length || 0) < (sapPodcastCount || 0) : (accountPlanHistory?.length || 0) < (sapHistoryCount || 0) : true}
              loader={false}
              className={classNames('o-x-hidden')}
              height="auto"
            >
              {podcastGenerate ? accountPlanPodcast?.map((doc, index) => renderPodcastRow(doc, index)) : accountPlanHistory?.map((doc, index) => renderHistoryRow(doc, index))}
              {((accountPlanHistoryLoading && !podcastGenerate) || (accountPlanPodcastLoading && podcastGenerate)) && (
                <DocumentHubTableSkeleton />
              )}
            </InfiniteScroll>
          </div>
        ) : null}
      </InnerStyleWrapper>
      <Preview
        drawerOpen={showSapPreview}
        setDrawerOpen={setShowSapPreview}
        // URL={selectedSapDoc?.previewUrl || ''}
        URL={previewUrlUrl}
        setTableRowId={setTableRowId}
      />
      <Modal
        getContainer={() => document.querySelector('.smart-account-plan-history-table') || document.body}
        open={isVisiblePopup}
        onOk={handleDelete}
        onCancel={togglePopup}
        centered
        cancelText="Cancel"
        okText="Yes"
        width={isTab ? '340px' : '406px'}
        className={classNames('delete-document-popup sap-history-delete-popup')}
      >
        <GilroyWhiteSvg />
        <span className="clear-text-modal">
          {`Are you sure you want to delete
          ${selectedSapDoc?.name || ''}?`}
        </span>
      </Modal>
      {
        limitPopup && (limitPopup.showPlanPopup || !limitPopup.remainingDownload)
          ? (
            <ProfilePopups
              title={limitPopup?.downloadPopupHeading || ''}
              description={limitPopup?.downloadPopupText || ''}
              type={limitPopup?.showPlanPopup}
              callToAction={limitPopup?.callToAction}
              contactUs={limitPopup?.contactusEmail}
              isDownloadPopup={false}
              loading={false}
              isPodcast
            />
          ) : null
      }
    </Wrapper>
  );
};
SmartAccountPlanHistoryTable.defaultProps = defaultProps;
export default SmartAccountPlanHistoryTable;
